import Vue from 'vue';

// Bootstrap
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons';


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// SCORM
import { SCORM } from 'pipwerks-scorm-api-wrapper';


// Vue Scroll
import VueScrollTo from 'vue-scrollto';
import store from './store';
import App from './App.vue';

/**
 * ANIMATE.CSS
 */
import 'animate.css';

import router from './router';

library.add(faBars);
library.add(faFile);
library.add(faChevronLeft);
library.add(faChevronRight);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueScrollTo, {
  offset: -80,
});
Vue.use(SCORM, {
  version: '1.2',
});

// require jquery
const $ = require('jquery');

window.$ = $;

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
